import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DssFormFieldModule } from '@dss/components/form-field';
import { DssMaskModule } from '@dss/components/mask';
import { DssTypographyModule } from '@dss/components/typography';
import { SwiperModule } from 'swiper/angular';
import { ButtonModule } from '../shared/components/forms/button/button.module';
import { TrackingModule } from '../shared/directives/tracking.module';
import { NormalizeImagePipe } from '../shared/pipes/normalize-image.pipe';
import { SecurityService } from '../shared/services/security.service';
import { SharedModule } from '../shared/shared.module';
import { BenefitsPackageComponent } from './components/benefits-package/benefits-package.componet';
import { CookiesAgreementComponent } from './components/cookies-agreement/cookies-agreement.component';
import { HeaderLandingComponent } from './components/header/header-landing.component';
import { LandingComponent } from './components/landing.component';
import { LegalComponent } from './components/legal/legal.component';
import { OfferCardComponent } from './components/offer-card/offer-card.component';
import { OfferComponent } from './components/offer/offer.component';
import { StepByStepComponent } from './components/step-by-step/step-by-step.componet';
import { LandingRoutingModule } from './landing-routing.module';
import { OfferItemComponent } from './offer-item/offer-item.component';
import { StartHttpService } from './services/start-http.service';

@NgModule({
  declarations: [
    LandingComponent,
    HeaderLandingComponent,
    OfferComponent,
    BenefitsPackageComponent,
    OfferCardComponent,
    StepByStepComponent,
    LegalComponent,
    OfferItemComponent,
    NormalizeImagePipe,
    CookiesAgreementComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    LandingRoutingModule,
    TrackingModule,
    DssTypographyModule,
    DssFormFieldModule,
    ButtonModule,
    SwiperModule,
    DssMaskModule,
  ],
  exports: [HeaderLandingComponent],
  providers: [StartHttpService, SecurityService],
})
export class LandingModule {}
